import { render, staticRenderFns } from "./EwaskatExtend.vue?vue&type=template&id=587c62ff&lang=pug&"
import script from "./EwaskatExtend.vue?vue&type=script&lang=js&"
export * from "./EwaskatExtend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports